import { useLayoutEffect, useRef, useState } from "react";

/**
 * 컨테이너 폭/높이를 ResizeObserver 로 추적해 viewBox 와 동일하게 맞춘다.
 * 1:1 픽셀 매핑 → 텍스트/막대가 가로 압축되지 않음.
 */
export function useContainerSize(initial = { w: 540, h: 240 }) {
  const ref = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState(initial);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () =>
      setSize({
        w: Math.max(120, Math.round(el.clientWidth)),
        h: Math.max(80, Math.round(el.clientHeight)),
      });
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return [ref, size] as const;
}
